
































































































































import { Component, Vue, Prop} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../lib/ajax';
import AbpBase from '../../../lib/abpbase';
@Component({
    name:'academic'
})
export default class Academic extends AbpBase  {
    initData:any = {
        searchData: {},
        tableData: {
            totalCount: 0,
            loading: true,
            title: [
                {
                    title: '序号',
                    key: 'serialNumber',
                    align: 'center',
                    width: 100
                },   
                {
                    title: '会议名称',
                    key: 'conferenceName',
                    align: 'center',
                    minWidth: 300,
                    render: (h:any, params:any)=>{
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'text'
                                },
                                style: {
                                    color: '#57a3f3',
                                    cursor: 'pointer'
                                },
                                on: {
                                    click: () => {
                                        this.ShowModal('detail', params.row);
                                    }
                                }
                            }, params.row.conferenceName)
                        ])
                    }
                },
                {
                    title: '会议类别',
                    key: 'conferenceTypeDesc',
                    align: 'center',
                    minWidth: 100
                },               
                {
                    title: '举办时间',
                    key: 'publishTime',
                    align: 'center',
                    minWidth: 250,
                    render: (h:any, params:any)=>{
                        let hostBeginDt = new Date(params.row.hostBeginDt),
                            hostEndDt = new Date(params.row.hostEndDt);                            
                        return h('Row', [
                            h('Col', {}, params.row.hostBeginDt && params.row.hostEndDt ? hostBeginDt.getFullYear()+'年'+(hostBeginDt.getMonth()+1)+'月'+hostBeginDt.getDate()+'日'+'-'+hostEndDt.getFullYear()+'年'+(hostEndDt.getMonth()+1)+'月'+hostEndDt.getDate()+'日' : '/')
                        ])
                    }
                },
                {
                    title: '举办地点',
                    key: 'hostAddress',
                    align: 'center',
                    minWidth: 100
                },  
                {
                    title: '主办单位',
                    key: 'conferenceOrganizName',
                    align: 'center',
                    minWidth: 100
                },
                {
                    title: '参会人员',
                    key: 'conferenceMember',
                    align: 'center',
                    minWidth: 100
                },   
                {
                    title: '会议规模',
                    key: 'conferenceSummary',
                    align: 'center',
                    minWidth: 100
                },   
                {
                    title: '参会人数',
                    key: 'accendCount',
                    align: 'center',
                    minWidth: 100
                }, 
                {
                    title: '提交论文数',
                    key: 'paperCount',
                    align: 'center',
                    minWidth: 100
                },  
                {
                    title: '特邀报告或宣读论文题目',
                    key: 'paperTitle',
                    align: 'center',
                    minWidth: 200
                },
                {
                    title: '奖励',
                    key: 'prize',
                    align: 'center',
                    minWidth: 100
                },   
                {
                    title: '备注',
                    key: 'remark',
                    align: 'center',
                    minWidth: 100
                },   
                {
                    title: '部门',
                    key: 'belongOrg',
                    align: 'center',
                    minWidth: 100,
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.belongOrg ? params.row.belongOrg.displayName : '/')
                        ])
                    }
                },     
                {
                    title: '操作',
                    key: 'action',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any) => {
                        return h('span', [
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.ShowModal('edit', params.row);
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginLeft: '20px'
                                },
                                on: {
                                    click: () => {
                                        this.Delete(params.row.id);
                                    }
                                }
                            }, '删除'),
                        ])
                    }
                }
            ],
            content: []
        },
        modalData: {
            type: '',
            title: '',
            status: false,
            btnSatus: true,
            loading: true,
            content: {}
        },
        dicData: {
            allDictionary: {},
            secondBelongOrg: []
        }
    }
    //获取列表数据
    async GetData() {
        this.initData.tableData.loading = true;
        let temp = (await Ajax.get('/api/services/app/Academic/GetByPageAsync', {params: this.initData.searchData})).data.result;
        this.initData.tableData.content = temp.items;
        this.initData.tableData.totalCount = temp.totalCount;
        if(this.initData.tableData.content.length == 0){
            this.$Message.error('暂无数据！') 
        }
        this.initData.tableData.loading = false;
    }
    //弹窗
    ShowModal(type:any, data:any) {
        (this as any).$refs.addForm.resetFields();
        this.initData.modalData.type = type;
        this.initData.modalData.content = {};
        if(type == 'detail'){
            this.initData.modalData.title = '学术活动详情';
        }else if(type == 'add'){
            this.initData.modalData.title = '学术活动新增';
        }else{
            this.initData.modalData.title = '学术活动编辑';
        }
        if(type != 'add'){                
            Ajax.get('/api/services/app/Academic/GetDetailAsync?Id='+data.id).then(async (res:any)=>{
                Object.assign(this.initData.modalData.content, res.data.result);
                this.initData.modalData.content.belongOrgId = res.data.result.belongOrg.id;
                if(res.data.result.belongOrg.id){
                    await this.GetSecondBelongOrg(res.data.result.belongOrg.id);
                    this.initData.modalData.content.secondBelongOrgId = res.data.result.secondBelongOrg ? res.data.result.secondBelongOrg.id : undefined;
                }
            })
        }
        this.initData.modalData.loading = false;
        this.initData.modalData.status = true;
    }
    //新增
    async Add() {
        (this as any).$refs.addForm.validate(async (valid:boolean)=>{
            if(this.initData.modalData.type == 'detail'){
                this.initData.modalData.status = false;
                return;
            }
            if(valid){
                this.initData.modalData.btnSatus = true;
                if(this.initData.modalData.type == 'add'){
                    Ajax.post('/api/services/app/Academic/CreateAsync', this.initData.modalData.content).then(()=>{
                        this.$Message.success('新增成功!');
                        this.GetData();
                        this.initData.modalData.status = false;
                    })
                }else if(this.initData.modalData.type == 'edit'){
                    Ajax.put('/api/services/app/Academic/UpdateAsync', this.initData.modalData.content).then(()=>{
                        this.$Message.success('修改成功!');
                        this.GetData();
                        this.initData.modalData.status = false;
                    })
                }
            }else{                    
                setTimeout(() => {
                    this.initData.modalData.btnSatus = false;
                    this.$nextTick(() => {
                        this.initData.modalData.btnSatus = true;
                    });
                }, 1000);
            }
        })
    }
    //删除
    async Delete(id:any) {
        await Ajax.delete('/api/services/app/Academic/DeleteAsync?Id='+id);
        this.$Message.success('删除成功!');
        this.GetData();            
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchData.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchData.MaxResultCount = perPage;
        this.GetData()
    }
    //初始化
    mounted() {
        this.GetDic();
        this.GetData();
    }
    Export() {
        (this as any).$root.Export(this.initData.searchData, '/api/ResearchFile/ExportAllAcademicAsync', '学术活动', 'xlsx');
    }
    //字典
    async GetDic() {
        //所有字典
        await this.$store.dispatch('project/GetAllDictionary');
        //部门字典
        await this.$store.dispatch('project/GetbearerOrg')
        this.$store.state.project.allDictionary.map((item:any) => {
            this.$set(this.initData.dicData.allDictionary, item.key, item.items.map((items:any) => {
                return {
                    label: items.displayName,
                    value: items.id
                }
            }));
        });
        this.initData.dicData.bearerOrg = this.$store.state.project.bearerOrgId;
    }
    //二级部门
    async GetSecondBelongOrg(id:any){
        if(!id) return;
        Ajax.get('/api/services/app/Organization/GetAllChildrenOrganizationByParentIdAsync?Id='+id).then((res:any)=>{
            this.initData.dicData.secondBelongOrg = res.data.result;
        })
    }
    //弹窗验证
    rules:any = {
        conferenceName: [{required: true, message: '请填写会议名称', trigger: 'blur'}],
        hostDt: [{required: true, type: 'date', message: '请填写举办时间', trigger: 'blur'}],
        instituteName: [{required: true, message: '请填写举办地点', trigger: 'blur'}],
        conferenceType: [{required: true, type: 'number', message: '请选择会议类别', trigger: 'blur'}],
        conferenceOrganizName: [{required: true, message: '请填写主办单位', trigger: 'blur'}],
        conferenceMember: [{required: true, message: '请填写参会人员', trigger: 'blur'}],
        belongOrgId: [{required: true, type: 'number', message: '请选择部门', trigger: 'blur'}],
        accendCount: [{required: true, type: 'number', message: '请填写参会人数', trigger: 'blur'}],
        paperCount: [{required: true, type: 'number', message: '请填写提交论文数', trigger: 'blur'}]
    }
}
